import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon/Icon";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authDrawerActions from "../../../actions/authDrawer";
import * as authDrawerConstants from "../../../constants/authDrawer";
import * as authUtils from "utils/auth";

import styles from "./AuthDrawer.css";

class RegisterOne extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    authUtils.setNonce();
    this.setState({
      fbAuthUrl: authUtils.getFacebookUrl(),
      linkedInAuthUrl: authUtils.getLinkedInUrl(),
    });
  }

  changeStep(step, event) {
    if (event) {
      event.preventDefault();
    }

    this.props.authDrawerActions.changeStep(step);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.muted}>
          Join Axios to save stories for later, get personalized news, and more!
        </div>
        <div className={styles.linkedInButton}>
          <a
            href={this.state.linkedInAuthUrl}
            className={classNames(
              styles.blueButton1,
              styles.block,
              styles.centered
            )}
          >
            <Icon name="linkedin-inverse" path="img" className={styles.icon} />
            Register with LinkedIn
          </a>
        </div>

        <div className={styles.facebookButton}>
          <a
            href={this.state.fbAuthUrl}
            className={classNames(
              styles.blueButton2,
              styles.block,
              styles.centered
            )}
          >
            <Icon name="facebook-inverse" path="img" className={styles.icon} />
            Register with Facebook
          </a>
        </div>

        <div className={styles.orWord}>OR</div>

        <div
          className={classNames(
            styles.marginTop10,
            styles.registerWithEmailButton
          )}
        >
          <a
            onClick={this.changeStep.bind(this, authDrawerConstants.REGISTER2)}
            href="#"
            className={classNames(
              styles.grayButton1,
              styles.block,
              styles.centered
            )}
          >
            <Icon name="envelope" path="img" className={styles.icon} />
            Register with Email
          </a>
        </div>

        <div className={classNames(styles.marginTop40, styles.textCenter)}>
          Already an Axios member?{" "}
          <a
            onClick={this.changeStep.bind(this, authDrawerConstants.SIGNIN)}
            href="#"
            className={classNames(styles.blackLink, styles.bold)}
          >
            Sign in now.
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authDrawer: state.authDrawer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authDrawerActions: bindActionCreators(authDrawerActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterOne);
